import { memo, useEffect, useState } from 'react'
import { Carousel } from 'react-bootstrap'

import s from './CustomSlider.module.scss'
import './CustomSlider.scss'

interface Props {
  images: string[]
  style?: React.CSSProperties
  itemStyle?: React.CSSProperties
}

export const CustomSlider = memo(({ images, style, itemStyle }: Props) => {
  const [slideChanged, setSlideChanged] = useState(0)

  const onSelect = (activeInd: number) => {
    setSlideChanged(activeInd)
  }

  useEffect(() => {
    Array.from(document.querySelectorAll('video')).forEach((video) => video.pause())
  }, [slideChanged])

  return (
    <Carousel className={s.sliderWrapper} style={style} interval={null} onSelect={onSelect}>
      {images?.length
        ? images?.map((image, ind) => {
            if (image?.includes('webm') || image?.includes('mp4')) {
              return (
                <Carousel.Item className={s.sliderItemVid} key={ind} style={itemStyle}>
                  <video className="d-block w-100" src={image} controls />
                </Carousel.Item>
              )
            }
            return (
              <Carousel.Item className={s.sliderItem} key={ind} style={itemStyle}>
                <img className="d-block w-100" src={image} alt="Slide" />
              </Carousel.Item>
            )
          })
        : null}
    </Carousel>
  )
})
